import { makeStyles } from 'tss-react/mui';
import Main from './main';

const useStyles = makeStyles()((theme) => ({
  wrapper: {
    margin: theme.spacing(2, 0, 6, 0),
  },
}));

type Props = {
  compact?: boolean;
};

const Loading = ({ compact = false }: Props) => {
  const { classes } = useStyles();

  const content = (
    <div className={classes.wrapper}>
      Loading...
    </div>
  );

  if (compact) {
    return content;
  }

  return (
    <Main compact>
      {content}
    </Main>
  );
};

export default Loading;
